<template>
  <v-form @submit.prevent="onSubmit" ref="form">
    <v-row>
      <v-col cols="12" md="6" class="py-0" v-for="(field, f) in productForm" :key="'fieldp-'+f">
        <Field :field="field" :item="resource" :index="f" />
      </v-col>
      
      
        <v-col cols="12" md="12" class="py-1">
          <v-row>
            <v-col cols="12" md="3" class="py-1" v-for="(media, m) in resource.media" :key="'media-' + m">
              <v-card :loading="loading" outlined>
                <span v-if="media.type === 'image'">
                  <img :src="media.url" width="100%">
                </span>
                <span v-if="media.type === 'video'">
                  <video :src="media.url" width="100%" controls></video>
                </span>
                <div>
                  <v-btn color="error" x-small class="ma-2" @click="removeMedia(m)">{{ i18n["delete"] }}</v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <input
            type="file"
            style="display: none"
            ref="fileImages"
            accept="*/*"
            @change="onFilePickedImages"
          >
        </v-col>
        <v-col cols="12" md="12" class="pb-2">
          <v-btn color="primary" small @click="addMedia()" :loading="uploading">{{ i18n["add_media"] }}</v-btn>
        </v-col>
        <v-col cols="12" md="12" class="py-0" v-if="resource.id">
        <v-row>
          <v-col cols="12" md="12" class="py-1">
            <v-row class="my-1 mb-3 elevation-1">
              <v-col cols="12" md="3" class="py-1" v-for="(tag, t) in resource.tags" :key="'tag-' + t">
                <div>
                  <v-chip label x-small>{{tag.en}}</v-chip>
                </div>
                <div>
                  <v-chip label x-small>{{tag.ar}}</v-chip>
                </div>
                <div>
                  <v-btn color="error" x-small class="ma-2" @click="removeTag(t)">{{ i18n["delete"] }}</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4" class="py-0 px-1" v-for="(field, f) in tagForm" :key="'fieldot-'+f">
            <Field :field="field" :item="selectedTag" :index="f" />
          </v-col>
          <v-col cols="12" md="12" class="pb-2">
            <v-btn color="primary" small @click="addExistingTag()" :loading="uploading">{{ i18n["add_tag"] }}</v-btn>
          </v-col>
          <v-col cols="12" md="4" class="py-0 px-1" v-for="(field, f) in newtagForm" :key="'fieldt-'+f">
            <Field :field="field" :item="newTag" :index="f" />
          </v-col>
          <v-col cols="12" md="12" class="pb-2">
            <v-btn color="primary" small @click="addTag()" :loading="uploading">{{ i18n["add_tag"] }}</v-btn>
          </v-col>
      
          <v-col cols="12" md="12" class="my-1 mb-3 elevation-1">
            <v-row>
              <v-col cols="12" md="12" class="py-1" v-for="(pricing, p) in resource.prices" :key="'pricing-' + p">
                <v-row>
                  <v-col cols="12" :md="f===0?3:2" class="py-0 px-1" v-for="(field, f) in priceForm" :key="'fieldop-'+f">
                    <Field :field="field" :item="pricing" :index="f" />
                  </v-col>
                  <v-btn color="error" x-small class="ma-2" @click="removePricing(p)">{{ i18n["delete"] }}</v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" :md="f===0?3:2" class="py-0 px-1" v-for="(field, f) in priceForm" :key="'fielda-'+f">
            <Field :field="field" :item="newPricing" :index="f" />
          </v-col>
          <v-col cols="12" md="12" class="py-1">
            <v-btn color="primary" small @click="addPricing()" :loading="uploading">{{ i18n["add_price"] }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" class="py-2 text-left">
        <v-btn @click="update()" color="primary" v-if="resource.id">{{ i18n["update"] }}</v-btn>
        <v-btn @click="store()" color="primary" v-else>{{ i18n["create"] }}</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { firebase, store, db, auth, storageRef } from '@/fb';
import { randomString } from '@/customFunction';
import Field from '@/components/Field.vue';
export default {
  components: {
    Field,
  },
  props:['resource', 'loading', 'countries', 'tags', 'all_countries'],
  data(){
    return {
      productForm:[
        {
          name: "country_id",
          type: 'select',
          returnValue:'id',
          label: 'origin',
          data:[...this.$props.all_countries],
          info: { en: '', ar: '' },
        },
        {
          name: "sku",
          type: 'text',
          label: 'product_sku',
          info: { en: '', ar: '' },
        },
        {
          name: "title_ar",
          type: 'text',
          label: 'title_ar',
          info: { en: '', ar: '' },
        },
        {
          name: "title_en",
          type: 'text',
          label: 'title_en',
          info: { en: '', ar: '' },
        },
        {
          name: "height",
          type: 'number',
          label: 'product_height',
          info: { en: '', ar: '' },
        },
        {
          name: "length",
          type: 'number',
          label: 'product_length',
          info: { en: '', ar: '' },
        },
        {
          name: "width",
          type: 'number',
          label: 'product_width',
          info: { en: '', ar: '' },
        },
        {
          name: "weight",
          type: 'number',
          label: 'product_weight',
          info: { en: '', ar: '' },
        },
        {
          name: "description_ar",
          type: 'editor',
          label: 'description_ar',
          info: { en: '', ar: '' },
        },
        {
          name: "description_en",
          type: 'editor',
          label: 'description_en',
          info: { en: '', ar: '' },
        },
        
      ],
      tagForm:[
        {
          name: "tag",
          type: 'select',
          label: 'add_tag',
          returnObject:true,
          data:[...this.$props.tags],
          info: { en: '', ar: '' },
        },
      ],
      selectedTag:{},
      newtagForm:[
        {
          name: "ar",
          type: 'text',
          label: 'label_ar',
          info: { en: '', ar: '' },
        },
        {
          name: "en",
          type: 'text',
          label: 'label_en',
          info: { en: '', ar: '' },
        },
      ],
      newTag:{},
      priceForm:[
        {
          name: "country_id",
          type: 'select',
          returnValue:'id',
          label: 'country',
          data:[...this.$props.countries],
          info: { en: '', ar: '' },
        },
        {
          name: "price",
          type: 'number',
          label: 'price',
          info: { en: '', ar: '' },
        },
        {
          name: "suggested_sale_price",
          type: 'number',
          label: 'suggested_sale_price',
          info: { en: '', ar: '' },
        },
        {
          name: "min_order_quantity",
          type: 'number',
          label: 'min_order_quantity',
          info: { en: '', ar: '' },
        },
        {
          name: "time_to_warehouse",
          type: 'number',
          label: 'time_to_warehouse',
          info: { en: '', ar: '' },
        },
        {
          name: "expiry_date",
          type: 'date',
          label: 'expiry_date',
          info: { en: '', ar: '' },
        },
        
        

        {
          name: "availability",
          type: 'switch',
          label: 'is_active',
          info: { en: '', ar: '' },
        },
      ],
      newPricing:{wholesale_product_id:this.resource.id},
      uploadProgress:0,
      uploading:false,
    }
    
  },
  methods:{
    update(){
      this.$emit('update')
    },
    store(){
      this.$emit('store')
    },
    async removePricing(p) {

    },
    
    async addPricing(){
      this.resource.prices.push(this.newPricing)
      this.newPricing = {wholesale_product_id:this.resource.id}
    },
    addExistingTag() {
      this.resource.tags.push(this.selectedTag.tag)
    },
    async removeTag(t){
      this.resource.tags.splice(t, 1)
    },
    async addTag(){
			const result = await this.$store.dispatch('postResource', { resource: '/wholesale-products/add-tag', value: {...this.newTag }})
      this.newTag = {}
      this.$emit('reload')
    },
    async removeMedia(m){
      this.resource.media.splice(m, 1)
    },
    addMedia(){
      this.$refs.fileImages.click()
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ninja/products/images' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = progress
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then(async (downloadURL) =>{
					this.uploadProgress = 0
          if(!this.resource.media) this.resource.media = []
          this.resource.media.push({
            url:downloadURL,
            type:this.determineFileType(downloadURL)
          })
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.uploadURL = null
      }
    },
    determineFileType(url) {
      const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'];
      const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];

      // Extract the pathname from the URL
      let pathname = new URL(url).pathname;
      // Decode URI to handle encoded characters
      pathname = decodeURIComponent(pathname);

      // Extract the file extension
      const match = pathname.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
      let extension = match ? match[1].toLowerCase() : null;

      if (imageExtensions.includes(extension)) {
        return 'image';
      } else if (videoExtensions.includes(extension)) {
        return 'video';
      } else {
        return 'file';
      }
    },
  },
  watch:{
    uploadProgress(){
      if(this.uploadProgress) {
        this.uploading = true
      } else {
        this.uploading = false
      }
    }
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  },
}
</script>

<style>

</style>